import { isAxiosError } from 'axios';
import { useErrorModalStore } from '~/stores/useErrorModalStore';

type Args = {
  onSuccess?: () => void;
  onError?: () => void;
};
export const useErrorHandler = ({ onError, onSuccess }: Args = {}) => {
  const { $sentryCaptureException } = useNuxtApp();
  const errorModal = useErrorModalStore();
  const { push } = useRouter();

  /**
   * 復帰可能な汎用エラーモーダル表示
   */
  const handleError = async (
    // 非同期・同期どちらにも対応
    func: () => Promise<void> | void,
    // HACK: エラー時のリダイレクト先を指定する
    toPath: string = '',
  ) => {
    try {
      await Promise.resolve(func());
      onSuccess?.();
    } catch (error) {
      $sentryCaptureException(error);
      onError?.();

      errorModal.open();
      // TODO AxiosErrorが返ってくると思われるので、条件分岐を書く
      // TODO AxiosErrorはVApiClientInitializerでハンドリングできるので、必要があればそちらにロジックを移す
      if (isAxiosError(error)) {
        console.log('axios error');
      }

      // NOTE: 現状アンケートで409エラーが出た場合のみ使用される
      if (toPath) {
        await push(toPath);
      }
    }
  };

  return {
    handleError,
  };
};
